<template>
	<div>
		<v-row justify="center">
			<v-col cols="12" md="2">
				<v-avatar size="140px" color="primary">
					<span class="white--text  fs-48 fw-bold">{{wholesaler_details.firm_name.substring(0, 2).toUpperCase()}}</span>
				</v-avatar>
			</v-col>
			<v-col cols="12" md="10">
				<div class="mt-5 pt-3">
					<p class="sub-title-text-dark fs-18">{{wholesaler_details.firm_name}}</p>
					<p class="secondary-text">{{wholesaler_details.email}}</p>
					<v-btn depressed @click="$router.push({name:'wholesaler-profile-details'})" class="" :v-ripple="false">	
						<p class="secodry-text-2 fs-13" >{{$lang.VIEW_DETAILS}}
							<v-icon  size="18">mdi-chevron-right</v-icon>
						</p>
					</v-btn>	
				</div>
			</v-col>
		</v-row>
		<v-row >
			<v-col cols="12" md="4" class="border-b">
				<p class="sub-title-text ">{{$lang.FAQS}}</p>
			</v-col>
			<v-col cols="12" md="4" class="border-b text-right">
				<v-btn text small  @click="$router.push({name:'faq'})">
					<span class="secodry-text-2 fs-13">
						View all
					</span>	
				</v-btn>	
			</v-col>
			<v-col cols="12" md="8">
				<v-expansion-panels accordion  flat>
					<v-expansion-panel
					v-for="(faq,i) in faq_list"
					:key="i"
					expand-icon=" asa"
					>
					<v-expansion-panel-header class="secondary-text">{{faq.question}}</v-expansion-panel-header>
					<v-expansion-panel-content class="secondary-text">
						Answer: {{faq.answer}}
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</v-col>
	</v-row>
	<v-row >
		<v-col cols="12" md="8" class="border-b">
			<p class="sub-title-text ">{{$lang.CONTACT_US}}</p>
		</v-col>
		<v-col cols="12" md="8">
			<!-- phone -->
			<div class="pt-2"> 
				<v-card class="d-flex flex-row pt-0" flat >
					<v-card   flat >
						<img src="../../assets/contact/phone.svg"  alt="img"  width="25px" class="mt-3">
					</v-card>
					<v-card class="pa-2" flat >
						<p class="secodry-text-3">{{medx_contact_number_1}}</p>
						<p class="secodry-text-3">{{medx_contact_number_2}}</p>
					</v-card>
				</v-card>
			</div>
			<!-- email -->
			<div class="pt-2">
				<v-card class="d-flex flex-row pt-0" flat >
					<v-card   flat >
						<img src="../../assets/contact/email.svg"  alt="img"  width="25px" class="mt-2">
					</v-card>
					<v-card class="pa-2" flat >
						<p class="secodry-text-3">{{medx_contact_email}}</p>
					</v-card>
				</v-card>	
			</div>
			<!-- location -->
			<div class="pt-2">
				<v-card class="d-flex flex-row  pt-0" flat >
					<v-card   flat >
						<img src="../../assets/contact/location.svg"  alt="img"  width="25px" class="mt-2">
					</v-card>
					<v-card class="pa-2 mt-2" flat >
						<p class="secodry-text-3">{{medx_contact_address}}</p>
					</v-card>
				</v-card>
			</div>
		</v-col>
	</v-row>
</div>
</template>
<script type="text/javascript">
export default {
	data () {
		return {
			wholesaler_details:{
				firm_name:"",
				email:"",
				full_address:"",
				landline_number:"",
				mobile:"",
				pincode:"",
				shop_number:"",
				wholesaler_id:"",
			},
			medx_contact_email:"",
			medx_contact_number_1:"",
			medx_contact_number_2:"",
			medx_contact_address:"",
			faq_list:[],
		}
	},

	created(){
		// this.$store.dispatch('drawer/setActiveTab',7) 
		this.getWholeSalerDertails()
		this.getContactAndFAQ()
	},
	methods:{
		/* fetcching wholesaler details*/ 
		getWholeSalerDertails(){
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let params={};

			const successHandler = (response) => {
				if (response.data.success)
					self.wholesaler_details=response.data.data
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)
				
			};
			self.request_GET( self,self.$urls.WHOLESALER_PROFILE,params,successHandler,null,null,finallyHandler)
		},

		/* Fetching FAQ and Contact details for medX*/ 

		getContactAndFAQ(){
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let params={};
			const successHandler = (response) => {

				if (response.data.success){
					self.medx_contact_email=response.data.medx_contact_email;
					self.medx_contact_number_1=response.data.medx_contact_number_1;
					self.medx_contact_number_2=response.data.medx_contact_number_2;
					self.medx_contact_address=response.data.medx_contact_address;
					self.faq_list=response.data.faq_list;

				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)

			};
			self.request_GET( self,self.$urls.CONTACT_DETAILS,params,successHandler,null,null,finallyHandler)
		},


	}
}


</script>